import React from 'react';
import TruncateMarkup from 'react-truncate-markup';
import StripTags from 'striptags';

import { AllHtmlEntities } from 'html-entities';

interface Props {
    htmlContent: string;
    lines?: number;
}

const HtmlSummary: React.StatelessComponent<Props> = (props: Props) => {
    const summaryContent = StripTags(new AllHtmlEntities().decode(props.htmlContent));
    return(
        <TruncateMarkup lines={props.lines}>
            <span>{summaryContent}</span>
        </TruncateMarkup>
    );
};

export default HtmlSummary;



// WEBPACK FOOTER //
// ./src/components/global/application/HtmlSummary.tsx